export function containSpaces(value: string) {
  return value.endsWith(' ') || value.startsWith(' ')
}
